import reducer from "./reducers";

export { default as widgetSelectors } from "./selectors";
export { default as widgetActions } from "./actions";
export { default as widgetTypes } from "./types";

export default reducer;



// WEBPACK FOOTER //
// ./dev/ducks/widget/index.js